import { Component, OnInit, ViewChild } from '@angular/core';
import { SlickCarouselComponent } from 'ngx-slick-carousel';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
})
export class CarouselComponent implements OnInit {
  @ViewChild('slickCarousel') slickModal!: SlickCarouselComponent;

  constructor() {}

  slides = [
    { img: '../assets/images/pic1.jpg' },
    { img: '../assets/images/pic2.jpg' },
    { img: '../assets/images/pic3.jpg' },
    { img: '../assets/images/pic4.jpg' },
    { img: '../assets/images/pic5.jpg' },
    { img: '../assets/images/pic6.jpg' },
    { img: '../assets/images/pic7.jpg' },
    { img: '../assets/images/pic8.jpg' },
    { img: '../assets/images/pic9.jpg' },
  ];

  slideConfig = {
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    infinite: true,
    speed: 1400,
    autoplaySpeed: 2000,
    arrows:true,
    cssEase:'ease',
    dots:false,
    fade:false,
    easing:'linear',
    pauseOnHover:true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  ngOnInit(): void {}
}
